import { useEffect, useState } from 'react';
import {
  currentImpersonation,
  subscribeImpersonation,
  type ImpersonationState,
} from '../../lib/api/impersonation';

/**
 * The active organization context, re-rendering when it starts or ends.
 *
 * Kept out of `lib/api` so the transport layer stays free of React — the token
 * has to be readable by `http.ts`, which is not a component.
 */
export function useImpersonation(): ImpersonationState | null {
  const [state, setState] = useState<ImpersonationState | null>(currentImpersonation());
  useEffect(() => subscribeImpersonation(setState), []);
  return state;
}
